import React from 'react';
import { CheckCheck, CheckCircle, Heart, Star } from 'lucide-react';
interface IconTooltipProps {
  icon: React.ReactNode;
  iconColor: string;
  label: string;
}
export function IconTooltip({
  icon,
  iconColor,
  label
}: IconTooltipProps) {
  return <div className="relative group" data-id="element-509">
      <div className={`text-${iconColor}`} data-id="element-510">{icon}</div>
      <div className="absolute bottom-full mb-2 left-1/2 transform -translate-x-1/2 hidden group-hover:block bg-gray-900 text-white text-xs px-2 py-1 rounded whitespace-nowrap" data-id="element-511">
        {label}
      </div>
    </div>;
}
interface IconFilterProps {
  icon: React.ReactNode;
  iconColor: string;
  label: string;
  isActive: boolean;
  onClick: () => void;
}
export function IconFilter({
  icon,
  iconColor,
  label,
  isActive,
  onClick
}: IconFilterProps) {
  return <button onClick={onClick} className={`flex items-center gap-2 px-3 py-1.5 rounded-lg transition-colors ${isActive ? `bg-${iconColor.split('-')[0]}-500/20 text-${iconColor}` : 'text-gray-400 hover:text-white'}`} data-id="element-512">
      {icon}
      <span data-id="element-513">{label}</span>
    </button>;
}